import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

import RequestAppliedOffersSkeleton from '../skeleton/request-applied-offers-skeleton';
import { renderAttachment } from '../../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    wideTd: {
        minWidth: `200px`,
        maxWidth: `300px`
    }
});

const StandaloneAppliedOffers = ({ reloadOffers, reservationReqId}) => {
    const [standaloneOffers, setStandaloneOffers] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        setLoading(true);
        axios.get(`/api/standaloneoffer?reservationReqId=${reservationReqId}`, { headers: headers })
            .then(res => {
                setStandaloneOffers(res.data);
                setTimeout(() => setLoading(false), 750);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [reloadOffers]);
    return (
        loading ?
            <RequestAppliedOffersSkeleton />
            :
            standaloneOffers.length > 0 ?
                <TableContainer>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell>More Details</TableCell>
                                <TableCell>Create Date</TableCell>
                                <TableCell>Categories Offers</TableCell>
                                <TableCell>No. Of Adults</TableCell>
                                <TableCell>Adult Price / Package (SGL)</TableCell>
                                <TableCell>Adult Price / Package (DBL)</TableCell>
                                <TableCell>Children(Price/Child)</TableCell>
                                <TableCell>Infants(Price/Infant)</TableCell>
                                <TableCell>Inclusions</TableCell>
                                <TableCell>Inclusions Notes</TableCell>
                                <TableCell>Payment Policy</TableCell>
                                <TableCell>Cancellation Policy</TableCell>
                                <TableCell>Free Policy</TableCell>
                                <TableCell>Exclusions Notes</TableCell>
                                <TableCell>Attachment</TableCell>
                                <TableCell>Created By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                standaloneOffers ?
                                    standaloneOffers.map((standaloneOffer, index) => (
                                        <Row key={index} row={standaloneOffer} />
                                    )) :
                                    null
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <>
                    You haven't applied any offers for this request.
                </>
    );
}

const Row = ({ row }) => {
    const classes = useRowStyles();
    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell component="th" scope="row">
                    <Link to={`/offer/standalone/${row.id}`}><OpenInNewOutlinedIcon /></Link>
                </TableCell>
                <TableCell className={classes.wideTd}>{row.createDate.replace('T', ' ').substring(0, 16)}</TableCell>
                <TableCell className={classes.wideTd}>
                    {row.flightOfferHeadline === null ? '' : <>&#9658;{`Flight: ${row.flightOfferHeadline}`}<br /></>}
                    {row.visaOfferHeadline === null ? '' : <>&#9658;{`Visa: ${row.visaOfferHeadline}`}<br /></>}
                    {row.hotelOfferHeadline === null ? '' : <>&#9658;{`Hotel: ${row.hotelOfferHeadline}`}<br /></>}
                    {row.registrationOfferHeadline === null ? '' : <>&#9658;{`Registration: ${row.registrationOfferHeadline}`}<br /></>}
                    {row.transportationOfferHeadline === null ? '' : <>&#9658;{`Transportation: ${row.transportationOfferHeadline}`}<br /></>}
                </TableCell>
                <TableCell>{row.noofAdults}</TableCell>
                <TableCell className={classes.wideTd}>{row.adultPackagePriceInSingle}</TableCell>
                <TableCell className={classes.wideTd}>{row.adultPackagePriceInDouble}</TableCell>
                <TableCell>{row.noofChilds === null ? '-' : `${row.noofChilds} (${row.childPrice})`}</TableCell>
                <TableCell>{row.noofInfants === null ? '-' : `${row.noofInfants} (${row.infantPrice})`}</TableCell>
                <TableCell className={classes.wideTd}>
                    {
                        row.reservationSupplierStandaloneOfferInclusionResources.map((inclusion, index) => (
                            <span key={index}>&#9658;{inclusion.inclusionDescription}<br /></span>  
                        ))
                    }
                </TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.inclusionsNotes}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.paymentPolicy}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.cancellationPolicy}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.freePolicy}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.exclusionsNotes}</TableCell>
                <TableCell className={classes.wideTd}>{renderAttachment(row.attachment)}</TableCell>
                <TableCell className={classes.wideTd}>{row.createdBy}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default StandaloneAppliedOffers;